import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useCatalogsStore = defineStore('catalogs', {
  state,
  getters,
  actions
})

export default useCatalogsStore
